export const artworkCount = 9;

export const artworkMaxWidth = 1000;
